import { useState } from "react";
import CheckboxInput from "Components/molecule/inputs/checkbox-input";
import PrimaryButton from "Components/atoms/buttons/primary-button";
import SecondaryButton from "Components/atoms/buttons/secondary-button";
import Employee from "models/employee";

interface ApproveOnBehalfFormProps {
    employees: Employee[]
    onSubmit: (employeeIds: string[]) => Promise<void>
    onCancel?: () => void
}

const ApproveOnBehalfForm = ({
    employees,
    onSubmit,
    onCancel
}: ApproveOnBehalfFormProps) => {
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleCheckboxChange = (employeeId: string) => {
        setSelectedIds(prev =>
            prev.includes(employeeId)
                ? prev.filter(id => id !== employeeId)
                : [...prev, employeeId]
        );
    }

    const handleSubmit = async () => {
        setIsSubmitting(true);
        await onSubmit(selectedIds);
        setIsSubmitting(false);
    }

    return <div className="form-container">
        <div>
            <h6>Select employees to approve on behalf of.</h6>
        </div>
        <div className="input-grid">
            {employees.map((employee) => (
                <CheckboxInput
                    key={employee.id}
                    name="employeeIds"
                    label={`${employee.commonName ?? employee.firstName} ${employee.lastName}`}
                    checked={selectedIds.includes(employee.id)}
                    onChange={() => handleCheckboxChange(employee.id)}
                />
            ))}
        </div>
        <div className="button-container">
            <PrimaryButton
                type='submit'
                onClick={handleSubmit}
                disabled={isSubmitting || selectedIds.length === 0}
            >
                {isSubmitting ? "Approving...." : "Approve for"}
            </PrimaryButton>
            {onCancel &&
                <SecondaryButton
                    disabled={isSubmitting}
                    onClick={onCancel}
                >
                    Cancel
                </SecondaryButton>
            }
        </div>
    </div>
}

export default ApproveOnBehalfForm